import { render } from "./PaymentSlipBufferPageList.vue?vue&type=template&id=3853d5bf&scoped=true"
import script from "./PaymentSlipBufferPageList.vue?vue&type=script&lang=ts"
export * from "./PaymentSlipBufferPageList.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-3853d5bf"

export default script